import React from "react";
import { Typography, Divider } from "antd";
import {
  StringListEditor,
  LabeledListEditor,
  QuickFactsEditor,
} from "./Editors";

const { Title, Text } = Typography;

/**
 * Step 2 — Details: quick facts, inclusions/exclusions, what's included,
 * and (Quick Trip only) highlights + important info. Pricing lives in its
 * own step; component/customization pricing lives in the Components step.
 */
const DetailsStep = ({ form, setForm, errors = {} }) => {
  const update = (patch) => setForm((prev) => ({ ...prev, ...patch }));
  const isQuickTrip = form.listType === "QUICK_TRIP";

  return (
    <div>
      <Title level={4}>Details</Title>
      <Text type="secondary">
        Quick facts, what's included, and the fine print travelers see
        before booking.
      </Text>

      <Divider />

      <Title level={5}>Quick facts</Title>
      <QuickFactsEditor
        value={form.quickFacts}
        onChange={(quickFacts) => update({ quickFacts })}
      />

      <Title level={5} style={{ marginTop: 24 }}>
        What it includes *
      </Title>
      {errors.inclusions && (
        <Text type="danger" style={{ fontSize: 12 }}>
          {errors.inclusions}
        </Text>
      )}
      {isQuickTrip ? (
        <StringListEditor
          value={form.inclusionsQuickTrip}
          onChange={(inclusionsQuickTrip) => update({ inclusionsQuickTrip })}
          placeholder="e.g. Hotel breakfast"
        />
      ) : (
        <LabeledListEditor
          value={form.inclusionsPackage}
          onChange={(inclusionsPackage) => update({ inclusionsPackage })}
        />
      )}

      <Title level={5} style={{ marginTop: 24 }}>
        What it does not include
      </Title>
      <StringListEditor
        value={form.exclusions}
        onChange={(exclusions) => update({ exclusions })}
        placeholder="e.g. Visa fees"
      />

      <Title level={5} style={{ marginTop: 24 }}>
        Included products
      </Title>
      <StringListEditor
        value={form.includedProducts}
        onChange={(includedProducts) => update({ includedProducts })}
        placeholder="e.g. Return flight"
      />

      {isQuickTrip && (
        <>
          <Title level={5} style={{ marginTop: 24 }}>
            Highlights
          </Title>
          <StringListEditor
            value={form.highlights}
            onChange={(highlights) => update({ highlights })}
            placeholder="e.g. Sunset boat ride"
          />

          <Title level={5} style={{ marginTop: 24 }}>
            Important info
          </Title>
          <StringListEditor
            value={form.importantInfo}
            onChange={(importantInfo) => update({ importantInfo })}
            placeholder="e.g. Bring a valid ID"
          />
        </>
      )}

      <Title level={5} style={{ marginTop: 24 }}>
        Cancellation policy
      </Title>
      <StringListEditor
        value={form.cancellationPolicy}
        onChange={(cancellationPolicy) => update({ cancellationPolicy })}
        placeholder="e.g. Full refund up to 48 hours before"
      />
    </div>
  );
};

export default DetailsStep;
